import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { AlertController } from '@ionic/angular';
import { getAnalytics, logEvent } from 'firebase/analytics';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    public afs: Firestore,
    public alertCtrl: AlertController,
    public httpClient: HttpClient
  ) {}

  trigger(event: string, parameters?: Record<string, string | number | boolean>) {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      logEvent(getAnalytics(), event, parameters);
    } catch (error) {
      console.warn('[analytics] skipped event', event, error);
    }
  }
}
